module.exports = __webpack_public_path__ + "img/jeu.55622e7d.png";